var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "large-12 medium-12 small-12 cell service-card-container",
    },
    [
      _c(
        "router-link",
        {
          attrs: {
            to: { name: "service", params: { slug: _vm.service.slug } },
          },
          nativeOn: {
            click: function ($event) {
              return _vm.panToLocation(_vm.service)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "service-card",
              class: [
                _vm.service.client_preference == 1 ? "in-client-network" : "",
                _vm.service.maintenance_slot == true && !this.makeId
                  ? "maintenance-slot"
                  : "",
              ],
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.service.name)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "address" }, [
                _c("span", { staticClass: "street" }, [
                  _vm._v(_vm._s(_vm.service.street)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "city" }, [
                  _vm._v(_vm._s(_vm.service.city)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "distance" }, [
                  _vm._v(_vm._s(_vm.service.distance) + " km"),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }